module.exports = "pegasus/assets/custom-3-twitter.png";